export const research = {
  id: 'research',
  name: 'Academic & Research',
  sectionOrder: ['education', 'experience', 'projects', 'skills', 'certifications'],
  defaultLayout: 'single-column',
  recommendedTemplates: ['harvard-classic'],
  components: {
    experience: 'experience-classic',
    skills: 'skills-simple-list',
    header: 'header-classic'
  }
};
export default research;
